import React, { useState, useEffect } from "react";
import "./Account_details.css";

function AccountDetails() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    displayedName: "",
  });

  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("userFormData"));
    if (savedData) {
      setFormData(savedData);
    }
  }, []);


  function handleChange(e) {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  function handleSubmit(e) {
    e.preventDefault();
    localStorage.setItem("userFormData", JSON.stringify(formData));
  };

  return (
    <div className="account-details-form-container">
      <form className="account-details-form" onSubmit={handleSubmit}>
        <div className="account-details-form-group-name-container">
          <div className="account-details-form-group">
            <label htmlFor="firstName">First Name *</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="account-details-form-group">
            <label htmlFor="lastName">Last Name *</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="account-details-form-group">
          <label htmlFor="email">Email *</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="account-details-form-group">
          <label htmlFor="displayedName">Displayed Name *</label>
          <input
            type="text"
            id="displayedName"
            name="displayedName"
            value={formData.displayedName}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="account-details-submit-btn">Save</button>
      </form>
    </div>
  );
};

export default AccountDetails;
